<div *ngIf="isVisible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">

        <form [formGroup]="form" (submit)="editPrompt()" (keydown.enter)="editPrompt()" method="POST">

          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button type="button" (click)="closeModal()" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
              <span class="sr-only">Close</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="sm:flex sm:items-start px-4 py-4 lg:px-6 lg:py-4">

            <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
              <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Edit</h3>
              <div class="mt-2">

                <div class="sm:col-span-4">
                  <fieldset [disabled]="loading$ | async">
                    <label for="prompt" class="block text-sm font-medium leading-6 text-gray-900">Prompt</label>
                    <div class="mt-2">
                      <textarea id="prompt" name="prompt" formControlName="prompt" rows="5" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#1c9ed1] sm:text-sm sm:leading-6"></textarea>
                    </div>

                    <div class="pt-1" *ngIf="form.get('prompt').touched && form.get('prompt').invalid">
                      <div class="ng-invalid text-xs text-red-500" *ngIf="form.get('prompt').errors?.['required']">
                        Prompt is required.
                      </div>
                    </div>
                  </fieldset>
                </div>

              </div>
            </div>

          </div>

          <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <button type="submit" [disabled]="loading$ | async" class="inline-flex w-full justify-center rounded-md bg-[#1c9ed1] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-90 sm:ml-3 sm:w-auto">Save</button>
            <button type="button" [disabled]="loading$ | async" (click)="closeModal()" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>
